import React from 'react';
import { BookOpen, MessageCircle, Activity, Target, MonitorPlay, Users, GraduationCap, Laptop } from 'lucide-react';
export function Features() {
  return <section className="py-12 md:py-20 bg-white" data-id="element-53">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-54">
        <div className="text-center mb-10 md:mb-14" data-id="element-55">
          <h2 className="font-display text-2xl md:text-4xl font-bold text-slate-900 mb-3" data-id="element-56">
            El sistema de clases listas para usar más completo
          </h2>
          <p className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-57">
            Creado para quienes quieren dejar de improvisar y empezar a dar
            clases claras, dinámicas y profesionales desde el primer día.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6 mb-12 md:mb-16" data-id="element-58">
          {[{
          icon: BookOpen,
          title: '+50 clases',
          desc: 'Listas para enseñar'
        }, {
          icon: MessageCircle,
          title: '+100 preguntas',
          desc: 'De conversación'
        }, {
          icon: Activity,
          title: '+100 actividades',
          desc: 'Y dinámicas'
        }, {
          icon: Target,
          title: '100% práctico',
          desc: 'Aplicable desde el día 1'
        }].map((feature, idx) => <div key={idx} className="bg-slate-50 rounded-xl md:rounded-2xl p-4 md:p-6 text-center border border-slate-100 hover:border-emerald-200 hover:shadow-md transition-all" data-id="element-59">
              <div className="w-10 h-10 md:w-14 md:h-14 mx-auto bg-emerald-100 text-emerald-600 rounded-lg md:rounded-xl flex items-center justify-center mb-3" data-id="element-60">
                <feature.icon className="w-5 h-5 md:w-7 md:h-7" data-id="element-61" />
              </div>
              <h3 className="text-base md:text-xl font-bold text-slate-900 mb-1" data-id="element-62">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-slate-600" data-id="element-63">
                {feature.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-slate-900 rounded-2xl md:rounded-3xl p-6 md:p-12 text-white relative overflow-hidden" data-id="element-64">
          <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl -mr-32 -mt-32" data-id="element-65"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-red-500/5 rounded-full blur-3xl -ml-32 -mb-32" data-id="element-66"></div>

          <div className="relative z-10" data-id="element-67">
            <h2 className="font-display text-xl md:text-3xl font-bold mb-7 md:mb-10 text-center" data-id="element-68">
              Adaptable a cualquier formato
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6" data-id="element-69">
              {[{
              icon: Users,
              text: 'Clases particulares'
            }, {
              icon: GraduationCap,
              text: 'Academias de idiomas'
            }, {
              icon: Laptop,
              text: 'Clases online'
            }, {
              icon: Users,
              text: 'Cursos grupales'
            }, {
              icon: Target,
              text: 'Niveles A1–A2'
            }].map((item, idx) => <div key={idx} className="flex flex-col items-center text-center gap-2 md:gap-3" data-id="element-70">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-slate-800 rounded-full flex items-center justify-center text-emerald-400 border border-slate-700" data-id="element-71">
                    <item.icon className="w-5 h-5 md:w-6 md:h-6" data-id="element-72" />
                  </div>
                  <span className="font-medium text-slate-300 text-xs md:text-base" data-id="element-73">
                    {item.text}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}